import Inventory from "@/services/models/inventory";
import Lafil013 from "@/services/models/lafil013";
import Lafil014 from "@/services/models/lafil014";
import Newspaper from "@/services/models/newspaper";
import Notebook from "@/services/models/notebook";
import Page from "@/services/models/page";
import Person from "@/services/models/person";

export {
    Inventory,
    Lafil013,
    Lafil014,
    Newspaper,
    Notebook,
    Page,
    Person
};